define([
  'globals',
  'jquery',
  'modernizr',
  'scroll-to-section',
  'cart-count',
  'option-state',
  'postal',
  'js-cookie',
  'local-storage',
  'cookies-factory',
  'content/product-plus/price-updater',
  'sticky-kit',
  'slick',
  'perfect-scrollbar'],
function (globals, $, Modernizr, scrollToSection, CartCount, optionState, postal, cookies, LocalStorage, cookiesFactory) {

  'use strict';

  const { isSamplingEnabled, isSamplingEnabledCecOnly, ssm } = globals;
  const isMobile = ssm.getState('mobile').active;
  const shouldDisplaySampling = (isSamplingEnabled && !isSamplingEnabledCecOnly) || (cookiesFactory.isInternalUser() && isSamplingEnabledCecOnly);

  if (window.location.hash === '#reviews') {
    scrollToSection('.ft-product-reviews');
  }

  if (!isMobile) {
    $('.ft-tabs-content').perfectScrollbar({
      suppressScrollX: true
    });
  }

  var localStorage = new LocalStorage();
  var widthQueryString = getParameterByName('width');
  var heightQueryString = getParameterByName('height');

  if (widthQueryString) {
    cookies.set('widthz', widthQueryString);
    localStorage.persist('SELECTED_WIDTH_STORAGE_KEY', { serializableValue: widthQueryString });
  }

  if (heightQueryString) {
    cookies.set('hghtz', heightQueryString);
    localStorage.persist('SELECTED_HEIGHT_STORAGE_KEY', { serializableValue: heightQueryString });
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  $('.ft-product-main-info [name=tabs]').on('click', function() {
    var $tabsContainer = $('.ft-tabs-content');
    $tabsContainer.scrollTop(0);
    if (!isMobile) {
      var containerHeight = $tabsContainer.outerHeight();
      var contentHeight = $('.ft-tabs-content div:visible:first').outerHeight();
      if (contentHeight > containerHeight) {
        $('.ft-product-main-info-text').addClass('has-scroll');
      } else {
        $('.ft-product-main-info-text').removeClass('has-scroll');
      }
      $('.ft-tabs-content').perfectScrollbar('update');
      $('.ft-product-main-info-text').removeClass('reach-end');
    }
  });

  $(document).on('ps-y-reach-end', function() {
    $('.ft-product-main-info-text').addClass('reach-end');
  });
  $(document).on('ps-scroll-up', function() {
    $('.ft-product-main-info-text').removeClass('reach-end');
  });

  $('.ft-product-main-info [name=tabs]:first-child').trigger('click');
  $('.ft-product-main-info-text .ft-tabs').on('click', function(event) {
    if ($(event.target).is('.ft-tabs')) {
      $('.ft-tabs-content').animate({
        scrollTop: '+=350'
      });
    }
  });

  // Start Image Slider
  $('.ft-product-image-slider').on('init', function (event, slick, direction) {
    $('.ft-product-image-slider > div').show();
  });
  $('.ft-product-image-slider').slick({
    dots: true
  });

  var cartCount = new CartCount();

  if (!Modernizr.csspointerevents) {
    require(['pointer-events-polyfill'], function (PointerEventsPolyfill) {
      PointerEventsPolyfill.initialize({});
    });
  }

  $('.ft-swatch-image').on('click', function () {
    var swatch = $(this).closest('.ft-swatch');
    $('.ft-swatch').not(swatch).removeClass('ft-swatch-selected');
    swatch.toggleClass('ft-swatch-selected');

    var productId = globals.productId;
    var optionId = $(this).data('option-id');

    if (swatch.hasClass('ft-swatch-selected')) {
      var choiceId = parseInt(swatch[0].dataset['choiceId']);
      optionState.setOptionState(productId, optionId, choiceId);
    }
    else {
      optionState.removeOptionState(productId, optionId);
    }

    postal.publish({ channel: 'productpage', topic: 'swatch.selection.changed'});
  });

  $('.ft-swatch:not(.ft-swatch-no-sample) ~ .ft-swatch-status').on('click', function (event) {
    var swatch = $(this).prevAll('.ft-swatch');
    if (!swatch.hasClass('ft-swatch-added')) {
      addSample(swatch);
    } else {
      removeSample(swatch);
    }
  });

  $('.ft-product-main-info-colors').on('click', function (event) {
    event.preventDefault();
    scrollToSection('.ft-product-colors-container');
  });

  var addSample = function (obj) {
    var sample = {
      productId: globals.productId,
      variantId: globals.variantId,
      productName: globals.productName,
      productCategory: globals.productCategory,
      productBrand: globals.productBrand,
      optionId: obj.data('option-id'),
      choiceId: obj.data('choice-id'),
    };
    $.post(globals.paths.addSample, sample, function (addSampleResult) {
      var $statusObj = obj.nextAll('.ft-swatch-status');
      $statusObj.find('span').text('Sample In Cart');
      $statusObj.addClass('ft-btn-attention');
      $statusObj.removeClass('ft-btn-outline');
      obj.addClass('ft-swatch-added');
      cartCount.addToCartCount($('.jb-header-menu-cart'));

      var thdAnalyticsEvent = {
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'cart add'
        },
        item: [{
          productInfo: {
            sku: addSampleResult.Data,
            productCategory: '', // samples category shall be an empty string
            productName: sample.productName,
            productType: 'sample',
            option: {
              color: obj.next('.ft-swatch-name').text().toLowerCase(),
              price: 0 // samples option price shall be zero
            },
            manufacturer: '' // samples manufacturer shall be an empty string
          },
          quantity: 1,
          price: {
            basePrice: 0 // samples base price shall be zero
          }
        }]
      };
      ddoEventInit(thdAnalyticsEvent);
    });
  };

  var removeSample = function (obj) {
    var sample = {
      productId: globals.productId,
      variantId: globals.variantId,
      optionId: obj.data('option-id'),
      choiceId: obj.data('choice-id')
    };
    $.post(globals.paths.removeSample, sample, function () {
      var $statusObj = obj.nextAll('.ft-swatch-status');
      $statusObj.find('span').text('Order Sample');
      $statusObj.addClass('ft-btn-outline');
      $statusObj.removeClass('ft-btn-attention');
      obj.removeClass('ft-swatch-added');
      cartCount.removeFromCartCount($('.jb-header-menu-cart'));
    });
  };

  $.get(globals.paths.getSampleCart, {}, function (data) {
    _.each(data.Data, function (item) {
      var $obj = $('.ft-swatch[data-choice-id=' + item.ChoiceId + ']');
      var $statusObj = $obj.nextAll('.ft-swatch-status');
      $obj.addClass('ft-swatch-added');
      $statusObj.find('span').text('Sample In Cart');
      $statusObj.removeClass('ft-btn-outline');
      $statusObj.addClass('ft-btn-attention');
    });
  });

  if (shouldDisplaySampling) {
    document.querySelectorAll('[data-obj="sample-btn"]').forEach(obj => {
      obj.classList.remove('dn');
      obj.classList.add('db');
    });
  }

});


$('#ColorAndReviewsTab div > button').click( function(){
  $('#ColorAndReviewsTab div > button').removeClass('active');
  $(this).addClass('active');
  var activeTab = $(this).attr('title');
  // show content block
  $('main#pip').attr('data-tab', activeTab);
  
  $([document.documentElement, document.body]).animate({
      scrollTop: ($('#scrollHere').offset().top)
  }, 500);
});
